import
  React, {
  useContext
} from 'react';

import
  PropTypes
from 'prop-types';

import
  QRCode
from 'qrcode.react';

import {
  Text,
  VContainerH
} from '@vodacom/web-common';

import {
  PrimaryButton
} from 'components';

import {
  ActivationStatus,
  CustomColors,
  VoucherShareMessageVariables
} from '../../../../constants';

import {
  VoucherGiftCard
} from './VoucherGiftCard';

import {
  DetailCard
} from '.';

import {
  formatVoucherCode,
  generateDynamicMessage,
  isEqual,
  printCurrency
} from 'helpers';

import {
  AppContext
} from 'context';

export const SummaryTab = (props) => {

  const { config } = useContext(AppContext);

  const ActiveCard = () => {

    return (

      <>
        <VContainerH
          margin={'16px 0'}
          border={`8px solid ${CustomColors.White}`}>

          <QRCode
            value={props.voucherCode}
            renderAs={'canvas'}
            size={184}/>
        </VContainerH>

        <Text
          fontSize={'16px'}
          padding={'0 0 32px'}
          lineHeight={'20px'}
          color={CustomColors.Grey8}
          fontWeight={'bold'}>

          {`Expires ${props.expiryDate}`}
        </Text>

        { navigator?.canShare &&

          <PrimaryButton
            height={'44px'}
            minHeight={'44px'}
            text={'Share voucher'}
            onClick={() => {

              const shareMessage = generateDynamicMessage(
                config?.voucherAdvanceConfig?.voucherShareMessage,
                {
                  [VoucherShareMessageVariables.value]: printCurrency(props.voucherValue),
                  [VoucherShareMessageVariables.description]: props.description,
                  [VoucherShareMessageVariables.code]: formatVoucherCode(props.voucherCode),
                  [VoucherShareMessageVariables.expiryDate]: props.expiryDate
                }
              );

              if (!navigator?.canShare?.({ text: shareMessage })) {
                return;
              }

              navigator.share?.({
                text: shareMessage
              });
            }}/>
        }
      </>
    );
  };

  const TextCard = ({ message }) => {

    return (

      <Text
        fontSize={'16px'}
        padding={'16px 0 0'}
        lineHeight={'20px'}
        color={CustomColors.Grey8}
        fontWeight={'bold'}>

        {message}
      </Text>
    );
  };

  const VoucherCodeCard = () => {

    return (

      <VContainerH
        padding={'20px 32px'}
        borderRadius={'4px'}
        backgroundColor={CustomColors.White}
        boxShadow={`0px 5px 15px ${CustomColors.TransparentBlack1}`}>

        <Text
          fontSize={'16px'}
          color={CustomColors.Grey8}
          textAlign={'center'}
          dangerouslySetInnerHTML={{ __html: config?.voucherAdvanceConfig?.voucherRedeemText }}/>

        <Text
          fontSize={'14px'}
          lineHeight={'18px'}
          padding={'16px 0 0'}
          color={CustomColors.Red1}
          fontWeight={'bold'}>

          {'VOUCHER CODE'}
        </Text>

        <Text
          fontSize={'20px'}
          lineHeight={'30px'}
          color={CustomColors.Grey8}
          fontWeight={'bold'}>

          {formatVoucherCode(props.voucherCode)}
        </Text>

        { isEqual(props.voucherStatus, ActivationStatus.RedeemPending)

            ? <ActiveCard/>

            : isEqual(props.voucherStatus, ActivationStatus.Redeemed)

              ? <TextCard
                  message={'This voucher has been redeemed'}/>

              : <TextCard
                  message={'This voucher has expired'}/>

        }

      </VContainerH>
    );
  };

  const Content = () => {

    return (

      <VContainerH>

        <VoucherGiftCard
          badgeText={props.voucherStatus}
          vendor={props.description}
          price={printCurrency(props.voucherValue)}
          expiryDate={props.expiryDate}
          type={'Voucher'}/>

        <VoucherCodeCard/>

        <DetailCard
          margin={'12px 0'}
          paymentMethod={props.paymentMethod}
          purchaseDate={props.purchaseDate}
          paymentDue={props.paymentDue}
          outstandingAmount={printCurrency(props.outstandingAmount)}
          paidAmount={printCurrency(props.voucherCost - props.outstandingAmount)}
          feeAmount={printCurrency(props.feeAmount)}
          total={printCurrency(props.voucherCost + props.feeAmount)}/>
      </VContainerH>
    );
  };

  return <Content/>;

};

SummaryTab.propTypes = {
  voucherCode: PropTypes.string.isRequired,
  expiryDate: PropTypes.string.isRequired,
  voucherRedeemed: PropTypes.bool
};

SummaryTab.defaultProps = {
  voucherCode: '',
  expiryDate: '',
  voucherRedeemed: false
};
